import {
  Cluster,
  Columns,
  FoldPanel,
  Row,
  Stack,
  Typography,
  TYPE_GROUPS,
  TYPE_RULES,
} from '@src/components';

/**
 * Live specimens of every type role. The styles come from Typography — this
 * file only lays the catalog out.
 */
export function TypeSection() {
  return (
    <FoldPanel
      id="type"
      title="Typography"
      hint="27 roles in four groups. New copy on a screen has to be one of these — add a role here rather than inventing a style at the call site."
      example={`<Typography role="title/page">Sign in to Secret Santa</Typography>
<Typography role="body/lead">Create a game, send the link, get a pair.</Typography>
<Typography as="label" role="label/field">Email</Typography>`}
    >
      {TYPE_GROUPS.map((group) => (
        <Stack gap={4} key={group.id}>
          <Cluster align="baseline" gap={3} rule="bottom">
            <Typography as="span" role="meta/caps">
              {group.label}
            </Typography>
            <Typography as="span" role="meta/helper">
              {group.note}
            </Typography>
          </Cluster>
          {group.items.map((item) => (
            <Row tone="catalog" as="div" key={item.role}>
              <Columns columns="meta" gap={4}>
                <Stack gap={1}>
                  <Typography as="code" role="meta/mono">
                    {item.role}
                  </Typography>
                  <Typography as="span" role="meta/helper">
                    {item.use}
                  </Typography>
                  <Typography as="span" role="meta/mono">
                    {item.spec}
                  </Typography>
                </Stack>
                <Cluster align="center">
                  <Typography role={item.role}>{item.sample}</Typography>
                </Cluster>
              </Columns>
            </Row>
          ))}
        </Stack>
      ))}

      <Stack gap={4}>
        <Cluster align="baseline" gap={3} rule="bottom">
          <Typography as="span" role="meta/caps">
            Rules
          </Typography>
        </Cluster>
        {TYPE_RULES.map((rule) => (
          <Typography as="p" role="body/sm" key={rule}>
            {rule}
          </Typography>
        ))}
      </Stack>
    </FoldPanel>
  );
}
